export default __webpack_public_path__ + "static/media/Pingry_testimonial.2c9d24ab.png";